"use client";

import React from "react";
import Link from "next/link";

const AffordableFinancing: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          Affordable Tooth Extractions with Flexible Financing
        </h2>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          The{" "}
          <Link
            href="/blog/emergency-dental-extraction-cost/"
            className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
          >
            cost of a tooth extraction
          </Link>{" "}
          in Queens shouldn&apos;t be a barrier to getting the care you need.
          At Smile4Me Dental Care, we accept most PPO insurance plans and offer{" "}
          <strong>
            flexible financing with up to 2 years at 0% interest,
          </strong>{" "}
          making it easier to proceed with treatment without financial stress.
          Whether you need a simple removal or a more involved surgical
          extraction, our team will review your insurance benefits and go over
          payment options before your appointment.
        </p>
      </div>
    </section>
  );
};

export default AffordableFinancing;
